import { useQuery } from '@tanstack/react-query';
import { AlarmFeedKey } from '@/types';
import { getAlarmFeed } from '../api/endpoints/alarms';

/** Alarm changes are pushed over a WebSocket (useAlarmStream); this slow poll is only the fallback if that socket is down. */
export const LIVE_ALARM_REFETCH_MS = 60_000;

export function useAlarmFeed(key: AlarmFeedKey) {
  return useQuery({
    queryKey: ['alarm-feed', key],
    queryFn: () => getAlarmFeed(key),
    refetchInterval: LIVE_ALARM_REFETCH_MS,
  });
}
